/* =========================================================
   SMB Sports Cricket Theme — core JS
   ========================================================= */
(function () {
  'use strict';

  /* ---------------- Header scroll state ---------------- */
  var header = document.querySelector('[data-header]');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 40);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------------- Mobile menu toggle ---------------- */
  var mobileToggle = document.querySelector('[data-mobile-menu-toggle]');
  var mobileNav = document.querySelector('[data-mobile-nav]');
  if (mobileToggle && mobileNav) {
    mobileToggle.addEventListener('click', function () {
      var open = mobileNav.classList.toggle('is-open');
      mobileToggle.querySelector('[data-icon-menu]').style.display = open ? 'none' : '';
      mobileToggle.querySelector('[data-icon-close]').style.display = open ? '' : 'none';
    });
  }

  /* ---------------- Mobile submenu accordions ---------------- */
  document.querySelectorAll('[data-mobile-expand-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var id = btn.getAttribute('data-mobile-expand-toggle');
      var panel = document.querySelector('[data-mobile-sub-panel="' + id + '"]');
      if (!panel) return;
      var open = panel.classList.toggle('is-open');
      btn.querySelector('[data-plus]').style.display = open ? 'none' : '';
      btn.querySelector('[data-minus]').style.display = open ? '' : 'none';
    });
  });

  /* ---------------- Desktop mega menu (hover) ---------------- */
  var megaTriggers = document.querySelectorAll('[data-mega-trigger]');
  var megaPanels = document.querySelectorAll('[data-mega-panel]');
  var megaCloseTimer;

  function openMega(id) {
    clearTimeout(megaCloseTimer);
    megaPanels.forEach(function (p) {
      p.classList.toggle('is-open', p.getAttribute('data-mega-panel') === id);
    });
  }
  function scheduleCloseMega() {
    megaCloseTimer = setTimeout(function () {
      megaPanels.forEach(function (p) { p.classList.remove('is-open'); });
    }, 150);
  }

  megaTriggers.forEach(function (trigger) {
    var id = trigger.getAttribute('data-mega-trigger');
    trigger.addEventListener('mouseenter', function () { openMega(id); });
    trigger.addEventListener('mouseleave', scheduleCloseMega);
    trigger.addEventListener('click', function (e) { e.preventDefault(); });
  });
  megaPanels.forEach(function (panel) {
    panel.addEventListener('mouseenter', function () { clearTimeout(megaCloseTimer); });
    panel.addEventListener('mouseleave', scheduleCloseMega);

    // hover-switch between categories inside a panel (with "hover intent")
    // Jab cursor tezi se kisi item ke upar se guzar kar right side ke sub-panel ki taraf
    // ja raha ho, to us raaste mein aane wale items activate nahi hotay. Item tab activate
    // hota hai jab cursor us par thehar/slow ho jaye, ya click / keyboard focus ho.
    var catButtons = panel.querySelectorAll('[data-mega-cat]');
    var intentTimer = null;
    var curX = 0, curY = 0, lastX = 0, lastY = 0;

    function activateCat(cat) {
      var catId = cat.getAttribute('data-mega-cat');
      catButtons.forEach(function (c) { c.classList.toggle('is-active', c === cat); });
      panel.querySelectorAll('[data-mega-sub-content]').forEach(function (content) {
        content.style.display = content.getAttribute('data-mega-sub-content') === catId ? '' : 'none';
      });
    }
    function cancelIntent() {
      clearTimeout(intentTimer);
      intentTimer = null;
    }
    function pollIntent(cat) {
      intentTimer = setTimeout(function () {
        var moved = Math.sqrt(Math.pow(curX - lastX, 2) + Math.pow(curY - lastY, 2));
        if (moved < 10) {            // cursor slow ho gaya => user isi item par aana chahta hai
          intentTimer = null;
          activateCat(cat);
        } else {                     // abhi tez move ho raha hai => dobara check karo
          lastX = curX; lastY = curY;
          pollIntent(cat);
        }
      }, 90);
    }

    panel.addEventListener('mousemove', function (e) { curX = e.clientX; curY = e.clientY; });
    panel.addEventListener('mouseleave', cancelIntent);

    catButtons.forEach(function (cat) {
      cat.addEventListener('mouseenter', function (e) {
        cancelIntent();
        if (cat.classList.contains('is-active')) return;
        curX = lastX = e.clientX;
        curY = lastY = e.clientY;
        pollIntent(cat);
      });
      cat.addEventListener('mouseleave', cancelIntent);
      cat.addEventListener('focus', function () { cancelIntent(); activateCat(cat); });
      cat.addEventListener('click', function () { cancelIntent(); activateCat(cat); });
    });
  });

  /* ---------------- Search bar toggle ---------------- */
  var searchToggle = document.querySelector('[data-search-toggle]');
  var searchBar = document.querySelector('[data-search-bar]');
  if (searchToggle && searchBar) {
    searchToggle.addEventListener('click', function () {
      var open = searchBar.classList.toggle('is-open');
      if (open) {
        var input = searchBar.querySelector('input[type="search"]');
        if (input) setTimeout(function () { input.focus(); }, 50);
      }
    });
  }

  /* ---------------- Footer accordion columns ---------------- */
  document.querySelectorAll('[data-footer-col-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var id = btn.getAttribute('data-footer-col-toggle');
      var body = document.querySelector('[data-footer-col-body="' + id + '"]');
      if (!body) return;
      var collapsed = body.classList.toggle('is-collapsed');
      var plus = btn.querySelector('[data-plus]');
      var minus = btn.querySelector('[data-minus]');
      if (plus) plus.style.display = collapsed ? '' : 'none';
      if (minus) minus.style.display = collapsed ? 'none' : '';
    });
  });

  /* ---------------- Generic accordion (product page) ---------------- */
  document.querySelectorAll('[data-accordion-trigger]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var panel = btn.nextElementSibling;
      if (!panel) return;
      var open = panel.classList.toggle('is-open');
      var icon = btn.querySelector('[data-chevron]');
      if (icon) icon.style.transform = open ? 'rotate(180deg)' : '';
    });
  });

  /* ---------------- Horizontal scroll carousels (products/testimonials/blog) ---------------- */
  document.querySelectorAll('[data-scroll-prev], [data-scroll-next]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var targetId = btn.getAttribute('data-scroll-target');
      var track = document.getElementById(targetId);
      if (!track) return;
      var dir = btn.hasAttribute('data-scroll-next') ? 1 : -1;
      track.scrollBy({ left: dir * (track.clientWidth * 0.7), behavior: 'smooth' });
    });
  });

  /* ---------------- Hero carousel autoplay ---------------- */
  function initHero(hero) {
    if (!hero || hero._heroReady) return;
    hero._heroReady = true;

    var slides = hero.querySelectorAll('[data-hero-slide]');
    var dots = hero.querySelectorAll('[data-hero-dot]');
    var delay = parseInt(hero.getAttribute('data-autoplay'), 10) || 1500;
    var current = 0;
    var timer = null;

    function show(i) {
      current = (i + slides.length) % slides.length;
      slides.forEach(function (s, idx) { s.classList.toggle('is-active', idx === current); });
      dots.forEach(function (d, idx) { d.classList.toggle('is-active', idx === current); });
    }
    function next() { show(current + 1); }
    function stop() { clearInterval(timer); timer = null; }
    function restart() {
      stop();
      if (slides.length > 1) timer = setInterval(next, delay);
    }

    hero.querySelectorAll('[data-hero-next]').forEach(function (b) { b.addEventListener('click', function () { next(); restart(); }); });
    hero.querySelectorAll('[data-hero-prev]').forEach(function (b) { b.addEventListener('click', function () { show(current - 1); restart(); }); });
    dots.forEach(function (d, idx) { d.addEventListener('click', function () { show(idx); restart(); }); });

    // Mouse hero par ho to slides ruk jayen (button click / text parhne ke liye) — sirf mouse devices par
    if (window.matchMedia && window.matchMedia('(hover: hover)').matches) {
      hero.addEventListener('mouseenter', stop);
      hero.addEventListener('mouseleave', restart);
    }

    // theme editor (customizer) ke liye hooks
    hero._heroShow = show;
    hero._heroStop = stop;
    hero._heroRestart = restart;
    hero._heroIndexOf = function (el) { return Array.prototype.indexOf.call(slides, el); };

    restart();
  }
  document.querySelectorAll('[data-hero]').forEach(initHero);

  // Shopify theme editor: section dobara render hota hai to hero ko dobara start karo
  document.addEventListener('shopify:section:load', function (e) {
    var hero = e.target.querySelector('[data-hero]');
    if (hero) initHero(hero);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    var hero = e.target.querySelector('[data-hero]');
    if (hero && hero._heroStop) hero._heroStop();
  });
  // Customizer mein kisi slide par click karo to wahi slide dikhe (autoplay ruk jaye)
  document.addEventListener('shopify:block:select', function (e) {
    var hero = e.target.closest && e.target.closest('[data-hero]');
    if (!hero || !hero._heroShow) return;
    var idx = hero._heroIndexOf(e.target);
    if (idx > -1) { hero._heroStop(); hero._heroShow(idx); }
  });
  document.addEventListener('shopify:block:deselect', function (e) {
    var hero = e.target.closest && e.target.closest('[data-hero]');
    if (hero && hero._heroRestart) hero._heroRestart();
  });

  /* ---------------- Video section lazy YouTube embed ---------------- */
  document.querySelectorAll('[data-video-trigger]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var frame = btn.closest('[data-video-frame]');
      var videoId = frame.getAttribute('data-video-id');
      var iframe = document.createElement('iframe');
      iframe.src = 'https://www.youtube-nocookie.com/embed/' + videoId + '?autoplay=1&rel=0&modestbranding=1';
      iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
      iframe.allowFullscreen = true;
      iframe.title = 'Video';
      frame.innerHTML = '';
      frame.appendChild(iframe);
    });
  });

  /* ---------------- Sticky add-to-cart bar ---------------- */
  var stickyBar = document.querySelector('[data-sticky-bar]');
  if (stickyBar) {
    window.addEventListener('scroll', function () {
      stickyBar.classList.toggle('is-visible', window.scrollY > 500);
    }, { passive: true });
  }

  /* ---------------- Collection: filter drawer toggle ---------------- */
  document.querySelectorAll('[data-filter-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      document.querySelectorAll('[data-filter-panel]').forEach(function (p) { p.classList.toggle('is-open'); });
      var overlay = document.querySelector('[data-filter-overlay]');
      if (overlay) overlay.classList.toggle('is-open');
    });
  });
  document.querySelectorAll('[data-filter-overlay]').forEach(function (ov) {
    ov.addEventListener('click', function () {
      document.querySelectorAll('[data-filter-panel]').forEach(function (p) { p.classList.remove('is-open'); });
      ov.classList.remove('is-open');
    });
  });

  /* =========================================================
     AJAX Cart (drawer + cart page) — fast path:
     - drawer/count HTML kabhi server se fetch nahi hoti; JSON cart response
       (jo /cart/add.js, /cart/change.js, /cart.js waise bhi return karte hain)
       se seedha client-side render hoti hai. Isi se add/remove "light speed" hai,
       aur cart bara ho to bhi speed control mein rehti hai (koi extra HTML round-trip nahi).
     ========================================================= */
  var cartDrawer = document.querySelector('[data-cart-drawer]');
  var cartOverlay = document.querySelector('[data-cart-overlay]');

  function openCartDrawer() {
    if (cartDrawer) cartDrawer.classList.add('is-open');
    if (cartOverlay) cartOverlay.classList.add('is-open');
  }
  function closeCartDrawer() {
    if (cartDrawer) cartDrawer.classList.remove('is-open');
    if (cartOverlay) cartOverlay.classList.remove('is-open');
  }
  // Delegated listeners: drawer content baar baar re-render hoti hai, is liye open/close
  // buttons har render ke baad bhi (bina dobara bind kiye) kaam karte hain.
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-open]')) { openCartDrawer(); }
    else if (e.target.closest('[data-cart-close]')) { closeCartDrawer(); }
  });
  if (cartOverlay) cartOverlay.addEventListener('click', closeCartDrawer);

  function renderCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = count; });
  }

  // Shop ke apne money format (jaise "Rs.{{amount_with_comma_separator}}") ke mutabiq format karta hai.
  function formatMoney(cents) {
    cents = cents || 0;
    var format = (window.Shopify && Shopify.money_format) || '${{amount}}';
    var addComma = function (n) { return n.replace(/\B(?=(\d{3})+(?!\d))/g, ','); };
    var value;
    if (/amount_no_decimals_with_comma_separator/.test(format)) {
      value = addComma(String(Math.round(cents / 100)));
    } else if (/amount_with_comma_separator/.test(format)) {
      value = addComma((cents / 100).toFixed(2));
    } else if (/amount_no_decimals_with_space_separator/.test(format)) {
      value = String(Math.round(cents / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    } else if (/amount_with_space_separator/.test(format)) {
      value = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    } else if (/amount_no_decimals/.test(format)) {
      value = addComma(String(Math.round(cents / 100)));
    } else {
      value = addComma((cents / 100).toFixed(2));
    }
    return format.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, value);
  }

  var escHtml = function (str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  };

  // Cart JSON (add.js/change.js/cart.js sab isi shape ka data dete hain) se drawer ka
  // poora HTML bana kar seedha DOM mein bitha deta hai — koi server round-trip nahi.
  function renderCartDrawer(cart) {
    var target = document.querySelector('[data-cart-drawer-content]');
    if (!target) return;

    var itemsHtml = '';
    if (cart.item_count === 0) {
      itemsHtml = '<p class="muted" style="text-align:center;padding:40px 0;">Your cart is empty.</p>';
    } else {
      itemsHtml = cart.items.map(function (item) {
        var variantLine = (item.variant_title && item.variant_title !== 'Default Title')
          ? '<p class="muted" style="font-size:12px;margin:2px 0 0;">' + escHtml(item.variant_title) + '</p>'
          : '';
        return (
          '<div class="cart-line-item">' +
            '<a href="' + escHtml(item.url) + '"><img src="' + escHtml(item.image) + '" alt="' + escHtml(item.title) + '"></a>' +
            '<div style="flex:1;min-width:0;">' +
              '<p style="font-size:10px;font-weight:600;text-transform:uppercase;color:rgb(var(--muted-foreground));margin:0;">' + escHtml(item.vendor) + '</p>' +
              '<a href="' + escHtml(item.url) + '" style="font-size:13px;font-weight:700;display:block;margin-top:2px;">' + escHtml(item.product_title) + '</a>' +
              variantLine +
              '<div style="display:flex;align-items:center;justify-content:space-between;margin-top:10px;">' +
                '<div class="qty-selector" style="transform:scale(.85);transform-origin:left;">' +
                  '<button type="button" data-cart-qty-change="-1" data-line-key="' + escHtml(item.key) + '">\u2212</button>' +
                  '<span data-cart-qty-value="' + escHtml(item.key) + '">' + item.quantity + '</span>' +
                  '<button type="button" data-cart-qty-change="1" data-line-key="' + escHtml(item.key) + '">+</button>' +
                '</div>' +
                '<span style="font-size:13px;font-weight:700;">' + formatMoney(item.final_line_price) + '</span>' +
              '</div>' +
            '</div>' +
          '</div>'
        );
      }).join('');
    }

    var footerHtml = '';
    if (cart.item_count > 0) {
      var threshold = parseInt((cartDrawer && cartDrawer.getAttribute('data-free-shipping-threshold')) || '0', 10);
      var shippingHtml = '';
      if (threshold > 0) {
        if (cart.total_price >= threshold) {
          shippingHtml = '<p style="font-size:12px;color:rgb(var(--primary));font-weight:700;margin-bottom:12px;">\uD83C\uDF89 You\u2019ve unlocked free shipping!</p>';
        } else {
          shippingHtml = '<p style="font-size:12px;margin-bottom:12px;">Add ' + formatMoney(threshold - cart.total_price) + ' more for free shipping</p>';
        }
      }
      footerHtml =
        '<div class="cart-drawer-footer">' +
          shippingHtml +
          '<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:16px;">' +
            '<span style="font-size:13px;font-weight:600;text-transform:uppercase;">Subtotal</span>' +
            '<span class="heading" style="font-size:18px;" data-cart-subtotal>' + formatMoney(cart.total_price) + '</span>' +
          '</div>' +
          '<form action="/cart" method="post">' +
            '<button type="submit" name="checkout" class="btn btn-primary btn-block">Checkout</button>' +
          '</form>' +
          '<a href="/cart" class="btn btn-outline btn-block" style="margin-top:8px;">View Cart</a>' +
        '</div>';
    }

    target.innerHTML =
      '<div class="cart-drawer-header">' +
        '<span class="heading" style="font-size:16px;">Your Cart (' + cart.item_count + ')</span>' +
        '<button data-cart-close aria-label="Close cart" style="background:none;border:none;color:rgb(var(--foreground));">' +
          '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
        '</button>' +
      '</div>' +
      '<div class="cart-drawer-items">' + itemsHtml + '</div>' +
      footerHtml;
  }

  // payload: FormData (product page form) ya object {id, quantity} (product card)
  function addToCart(payload) {
    var opts = { method: 'POST', headers: { Accept: 'application/json' } };
    if (payload instanceof FormData) {
      opts.body = payload;
    } else {
      opts.headers['Content-Type'] = 'application/json';
      opts.body = JSON.stringify(payload);
    }
    return fetch('/cart/add.js', opts)
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) throw new Error(data.description || data.message || 'Add to cart failed');
          return data;
        });
      })
      .then(function () {
        return fetch('/cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        renderCartDrawer(cart);
        renderCartCount(cart.item_count);
        openCartDrawer();
      });
  }

  // Product page form submit
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('[data-product-form]')) return;
    e.preventDefault();
    var submitBtn = form.querySelector('[type="submit"]');
    if (submitBtn) submitBtn.disabled = true;

    addToCart(new FormData(form))
      .catch(function (err) { console.error('Add to cart failed', err); alert(err.message); })
      .finally(function () { if (submitBtn) submitBtn.disabled = false; });
  });

  // Cart line quantity change (drawer ke andar) — /cart/change.js khud poora cart JSON
  // deta hai, is liye ek hi request mein kaam ho jata hai, koi extra fetch nahi.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cart-qty-change]');
    if (!btn || !btn.hasAttribute('data-line-key')) return;
    var key = btn.getAttribute('data-line-key');
    var delta = parseInt(btn.getAttribute('data-cart-qty-change'), 10);
    var qtyEl = document.querySelector('[data-cart-qty-value="' + key + '"]');
    var newQty = Math.max(0, (parseInt(qtyEl ? qtyEl.textContent : '1', 10) || 1) + delta);
    btn.disabled = true;

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: newQty }),
    })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        renderCartCount(cart.item_count);
        renderCartDrawer(cart);
      })
      .catch(function (err) { console.error('Cart update failed', err); btn.disabled = false; });
  });

  // Cart PAGE (/cart) quantity +/- and remove — same one-request pattern, DOM turant
  // patch hoti hai (koi page reload nahi), taake qty/remove bhi "light speed" mehsoos ho.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cart-page-qty]');
    if (!btn) return;
    var key = btn.getAttribute('data-cart-page-key');
    var delta = parseInt(btn.getAttribute('data-cart-page-qty'), 10);
    var qtyEl = document.querySelector('[data-cart-qty-value="' + key + '"]');
    var newQty = Math.max(0, (parseInt(qtyEl ? qtyEl.textContent : '1', 10) || 1) + delta);
    var card = btn.closest('.cart-line-item-card');
    if (card) card.style.opacity = '.5';
    btn.disabled = true;

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: newQty }),
    })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        renderCartCount(cart.item_count);

        if (cart.item_count === 0) {
          // Poora cart khali — is rare case mein page reload se saaf "empty cart" state dikhti hai.
          window.location.reload();
          return;
        }

        var updatedItem = cart.items.filter(function (i) { return i.key === key; })[0];
        if (!updatedItem && card) {
          // Item hat gaya: card ko fade karke turant DOM se nikal do.
          card.style.transition = 'opacity .15s ease, max-height .2s ease, margin .2s ease, padding .2s ease';
          card.style.maxHeight = card.offsetHeight + 'px';
          requestAnimationFrame(function () {
            card.style.opacity = '0';
            card.style.maxHeight = '0px';
            card.style.marginTop = '0'; card.style.marginBottom = '0';
            card.style.paddingTop = '0'; card.style.paddingBottom = '0';
            card.style.overflow = 'hidden';
          });
          setTimeout(function () { card.remove(); }, 220);
        } else if (updatedItem && card) {
          if (qtyEl) qtyEl.textContent = updatedItem.quantity;
          var priceEl = card.querySelector('.cart-line-price');
          if (priceEl) priceEl.textContent = formatMoney(updatedItem.final_line_price);
          card.style.opacity = '';
          btn.disabled = false;
        }

        var subtotalEl = document.querySelector('[data-cart-subtotal]');
        if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
        var countTextEl = document.querySelector('[data-cart-item-count-text]');
        if (countTextEl) countTextEl.textContent = cart.item_count + (cart.item_count === 1 ? ' item in your cart' : ' items in your cart');
      })
      .catch(function (err) {
        console.error('Cart update failed', err);
        if (card) card.style.opacity = '';
        btn.disabled = false;
      });
  });

  /* =========================================================
     Wishlist (localStorage-based — Shopify has no native wishlist)
     ========================================================= */
  var WISHLIST_KEY = 'smb_wishlist';

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || [];
    } catch (e) { return []; }
  }
  function saveWishlist(items) {
    try { localStorage.setItem(WISHLIST_KEY, JSON.stringify(items)); } catch (e) {}
  }
  function isWishlisted(id) {
    return getWishlist().some(function (item) { return String(item.id) === String(id); });
  }
  function renderWishlistCount() {
    var count = getWishlist().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) { el.textContent = count; });
  }
  function renderWishlistDrawer() {
    var container = document.querySelector('[data-wishlist-drawer-content]');
    if (!container) return;
    var items = getWishlist();
    if (items.length === 0) {
      container.innerHTML =
        '<div class="cart-drawer-header"><span class="heading" style="font-size:16px;">Wishlist (0)</span>' +
        '<button data-wishlist-close aria-label="Close" style="background:none;border:none;color:rgb(var(--foreground));">' +
        '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg></button></div>' +
        '<div class="cart-drawer-items"><p class="muted" style="text-align:center;padding:40px 0;">Your wishlist is empty.</p></div>';
      return;
    }
    var rows = items.map(function (item) {
      return (
        '<div class="cart-line-item">' +
        '<a href="' + item.url + '"><img src="' + item.image + '" alt="' + item.title + '"></a>' +
        '<div style="flex:1;min-width:0;">' +
        '<a href="' + item.url + '" style="font-size:13px;font-weight:700;display:block;">' + item.title + '</a>' +
        '<div style="display:flex;align-items:center;justify-content:space-between;margin-top:10px;">' +
        '<span style="font-size:13px;font-weight:700;color:rgb(var(--primary));">' + item.price + '</span>' +
        '<button type="button" data-wishlist-remove="' + item.id + '" style="background:none;border:none;color:rgb(var(--muted-foreground));font-size:11px;text-decoration:underline;">Remove</button>' +
        '</div></div></div>'
      );
    }).join('');
    container.innerHTML =
      '<div class="cart-drawer-header"><span class="heading" style="font-size:16px;">Wishlist (' + items.length + ')</span>' +
      '<button data-wishlist-close aria-label="Close" style="background:none;border:none;color:rgb(var(--foreground));">' +
      '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg></button></div>' +
      '<div class="cart-drawer-items">' + rows + '</div>';
  }
  function syncWishlistHearts() {
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var id = btn.getAttribute('data-wishlist-id');
      btn.classList.toggle('is-active', isWishlisted(id));
    });
  }

  var wishlistDrawer = document.querySelector('[data-wishlist-drawer]');
  var wishlistOverlay = document.querySelector('[data-wishlist-overlay]');
  function openWishlistDrawer() {
    renderWishlistDrawer();
    if (wishlistDrawer) wishlistDrawer.classList.add('is-open');
    if (wishlistOverlay) wishlistOverlay.classList.add('is-open');
  }
  function closeWishlistDrawer() {
    if (wishlistDrawer) wishlistDrawer.classList.remove('is-open');
    if (wishlistOverlay) wishlistOverlay.classList.remove('is-open');
  }
  document.querySelectorAll('[data-wishlist-open]').forEach(function (b) { b.addEventListener('click', openWishlistDrawer); });
  if (wishlistOverlay) wishlistOverlay.addEventListener('click', closeWishlistDrawer);

  // Toggle heart on a product card
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();

    var id = btn.getAttribute('data-wishlist-id');
    var items = getWishlist();
    var existingIndex = items.findIndex(function (item) { return String(item.id) === String(id); });

    if (existingIndex > -1) {
      items.splice(existingIndex, 1);
      btn.classList.remove('is-active');
    } else {
      items.push({
        id: id,
        title: btn.getAttribute('data-wishlist-title') || '',
        url: btn.getAttribute('data-wishlist-url') || '#',
        image: btn.getAttribute('data-wishlist-image') || '',
        price: btn.getAttribute('data-wishlist-price') || '',
      });
      btn.classList.add('is-active');
    }
    saveWishlist(items);
    renderWishlistCount();
    if (wishlistDrawer && wishlistDrawer.classList.contains('is-open')) renderWishlistDrawer();
  });

  // Remove item from inside the wishlist drawer
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist-remove]');
    if (!btn) return;
    var id = btn.getAttribute('data-wishlist-remove');
    var items = getWishlist().filter(function (item) { return String(item.id) !== String(id); });
    saveWishlist(items);
    renderWishlistCount();
    renderWishlistDrawer();
    syncWishlistHearts();
  });

  document.querySelectorAll('[data-wishlist-close]').forEach(function (b) {
    b.addEventListener('click', closeWishlistDrawer);
  });
  // delegated because the close button is injected dynamically into the drawer
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-wishlist-close]')) closeWishlistDrawer();
  });

  // Initial state on page load
  syncWishlistHearts();
  renderWishlistCount();

  /* =========================================================
     Recently Viewed (localStorage-based — Shopify has no native browsing history)
     ========================================================= */
  var RV_KEY = 'smb_recently_viewed';
  var RV_MAX = 12;

  function getRecentlyViewed() {
    try { return JSON.parse(localStorage.getItem(RV_KEY)) || []; } catch (e) { return []; }
  }
  function saveRecentlyViewed(items) {
    try { localStorage.setItem(RV_KEY, JSON.stringify(items)); } catch (e) {}
  }

  var rvTracker = document.querySelector('[data-track-recently-viewed]');
  if (rvTracker) {
    var currentId = rvTracker.getAttribute('data-rv-id');
    var entry = {
      id: currentId,
      title: rvTracker.getAttribute('data-rv-title'),
      url: rvTracker.getAttribute('data-rv-url'),
      image: rvTracker.getAttribute('data-rv-image'),
      price: rvTracker.getAttribute('data-rv-price'),
      vendor: rvTracker.getAttribute('data-rv-vendor'),
      compare: rvTracker.getAttribute('data-rv-compare') || '',
      discount: rvTracker.getAttribute('data-rv-discount') || '',
      variant: rvTracker.getAttribute('data-rv-variant') || '',
      available: rvTracker.getAttribute('data-rv-available') !== 'false',
    };
    var items = getRecentlyViewed().filter(function (i) { return String(i.id) !== String(currentId); });
    items.unshift(entry);
    if (items.length > RV_MAX) items = items.slice(0, RV_MAX);
    saveRecentlyViewed(items);

    // Render the slider, excluding the product currently being viewed
    var track = document.querySelector('[data-recently-viewed-track]');
    var section = document.querySelector('[data-recently-viewed-section]');
    var toRender = getRecentlyViewed().filter(function (i) { return String(i.id) !== String(currentId); });

    if (track && section) {
      if (toRender.length === 0) {
        section.style.display = 'none';
      } else {
        section.style.display = '';
        var quickAdd = section.getAttribute('data-quick-add') !== 'false';

        var esc = function (str) {
          return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
            return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
          });
        };

        var ICON_BAG = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z"/><path d="M3 6h18"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>';
        var ICON_EYE = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8Z"/><circle cx="12" cy="12" r="3"/></svg>';
        var ICON_HEART = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.6l-1-1a5.5 5.5 0 0 0-7.8 7.8l1 1L12 21l7.8-7.6 1-1a5.5 5.5 0 0 0 0-7.8Z"/></svg>';

        // Same markup as snippets/product-card.liquid so the cards look/behave identically
        var cardHTML = function (item) {
          var soldOut = item.available === false;
          var actions = quickAdd
            ? '<div class="product-card-actions" onclick="event.preventDefault()">' +
                '<form onsubmit="return false;">' +
                  '<button type="button" class="btn btn-primary" data-rv-add data-variant="' + esc(item.variant || '') + '" data-url="' + esc(item.url) + '"' + (soldOut ? ' disabled' : '') + '>' +
                    ICON_BAG + (soldOut ? 'Sold Out' : 'Add to Cart') +
                  '</button>' +
                '</form>' +
                '<button type="button" class="product-card-quickview" aria-label="Quick view" data-rv-view data-url="' + esc(item.url) + '">' + ICON_EYE + '</button>' +
              '</div>'
            : '';
          var badge = item.discount ? '<span class="badge badge-light">-' + esc(item.discount) + '%</span>' : '';
          return (
            '<div class="product-card" data-product-card>' +
              '<a href="' + esc(item.url) + '" class="product-card-media">' +
                '<div class="image-div">' +
                  '<img src="' + esc(item.image) + '" alt="' + esc(item.title) + '" loading="lazy">' +
                  actions +
                '</div>' +
                '<div class="product-card-badges">' + badge + '</div>' +
                '<button class="product-card-wishlist" data-wishlist-toggle data-wishlist-id="' + esc(item.id) + '"' +
                  ' data-wishlist-title="' + esc(item.title) + '" data-wishlist-url="' + esc(item.url) + '"' +
                  ' data-wishlist-image="' + esc(item.image) + '" data-wishlist-price="' + esc(item.price) + '"' +
                  ' aria-label="Add to wishlist" onclick="event.preventDefault()">' + ICON_HEART + '</button>' +
              '</a>' +
              '<div class="product-card-body">' +
                (item.vendor ? '<p class="product-card-vendor">' + esc(item.vendor) + '</p>' : '') +
                '<a href="' + esc(item.url) + '"><h3 class="product-card-title">' + esc(item.title) + '</h3></a>' +
                '<div class="product-card-price"><span class="price-current">' + esc(item.price) + '</span>' +
                  (item.compare ? '<span class="price-compare">' + esc(item.compare) + '</span>' : '') +
                '</div>' +
              '</div>' +
            '</div>'
          );
        };

        track.innerHTML = toRender.map(function (item) {
          return '<div class="rv-item">' + cardHTML(item) + '</div>';
        }).join('');
        syncWishlistHearts();

        // Add to Cart / Quick view buttons inside the slider
        track.addEventListener('click', function (e) {
          var add = e.target.closest('[data-rv-add]');
          if (add) {
            e.preventDefault(); e.stopPropagation();
            add.disabled = true;
            var variantId = add.getAttribute('data-variant');
            var getVariant = variantId
              ? Promise.resolve(variantId)
              : fetch(add.getAttribute('data-url').split('?')[0] + '.js')   // older saved items have no variant id
                  .then(function (r) { return r.json(); })
                  .then(function (p) {
                    var v = p.variants.filter(function (x) { return x.available; })[0];
                    if (!v) throw new Error('Sold out');
                    return v.id;
                  });
            getVariant
              .then(function (id) { return addToCart({ id: id, quantity: 1 }); })
              .catch(function (err) { console.error('Add to cart failed', err); })
              .finally(function () { add.disabled = false; });
            return;
          }
          var view = e.target.closest('[data-rv-view]');
          if (view) {
            e.preventDefault(); e.stopPropagation();
            window.location.href = view.getAttribute('data-url');
          }
        });

        // Arrows (desktop) — swipe/scroll works natively on touch devices
        var prevBtn = section.querySelector('[data-rv-prev]');
        var nextBtn = section.querySelector('[data-rv-next]');
        var arrows = section.querySelector('[data-rv-arrows]');
        var stepSize = function () {
          var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
          return track.clientWidth + gap;   // one full "page" (3 cards)
        };
        var updateArrows = function () {
          var max = track.scrollWidth - track.clientWidth - 2;
          if (arrows) arrows.style.display = max > 0 ? '' : 'none';
          if (prevBtn) prevBtn.disabled = track.scrollLeft <= 2;
          if (nextBtn) nextBtn.disabled = track.scrollLeft >= max;
        };
        if (prevBtn) prevBtn.addEventListener('click', function () { track.scrollBy({ left: -stepSize(), behavior: 'smooth' }); });
        if (nextBtn) nextBtn.addEventListener('click', function () { track.scrollBy({ left: stepSize(), behavior: 'smooth' }); });
        track.addEventListener('scroll', updateArrows, { passive: true });
        window.addEventListener('resize', updateArrows);
        window.addEventListener('load', updateArrows);
        updateArrows();
      }
    }
  }

  window.SMBTheme = { openCartDrawer: openCartDrawer, closeCartDrawer: closeCartDrawer, renderCartDrawer: renderCartDrawer, addToCart: addToCart, formatMoney: formatMoney };
})();